import { Entity } from '../../../../../common/ddd/entity.base';

export interface BaseAppGoalEntityProps {
  appMetric: number;
}

export abstract class BaseAppGoalEntity extends Entity<BaseAppGoalEntityProps> {
  protected _id: string;
  protected _goalValue: number;
  public validate() {}

  get appMetric() {
    return this.props.appMetric;
  }

  setGoalValue(value: number) {
    this._goalValue = value;
  }

  get goalValue() {
    return this._goalValue;
  }

  get deviationFromGoalPercentage() {
    const percentage =
      100 *
      ((this.appMetric - this.goalValue) /
        (this.goalValue > 0 ? this.goalValue : 1));
    return (
      (percentage < 0
        ? -Math.round(Math.abs(percentage))
        : Math.round(percentage)) || 0
    );
  }
}
